export default "__VITE_ASSET__CztYEKd1__"